module.exports = __webpack_public_path__ + "img/ic_pin_end.3c849ba2.png";